import { Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ObtenerInformacionRubroPrestamoME, PrestamoRubloModeloMLS, PrestamoService } from 'src/app/open-api';

@Component({
  selector: 'app-prestamo-rubros',
  templateUrl: './prestamo-rubros.component.html',
  styleUrls: ['./prestamo-rubros.component.scss']
})
export class PrestamoRubrosComponent implements OnInit {

  @Input() set SecuencialPrestamo(secuencial: number) {
    this.secuencialPrestamo = secuencial;
    this.ObtenerRubros();
  }
  rubros: PrestamoRubloModeloMLS[] = [];
  rubrosLista: PrestamoRubloModeloMLS[] = [];
  secuencialPrestamo = 0;
  cantidad = 0;
  pagina = 1;
  paginaTamanio = 3;

  constructor(
    private prestamoService: PrestamoService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  ListaRubros() {
    this.rubrosLista = this.rubros
      .slice((this.pagina - 1) * this.paginaTamanio, (this.pagina - 1) * this.paginaTamanio + this.paginaTamanio);
  }

  ObtenerRubros() {
    this.spinner.show();
    const parametro: ObtenerInformacionRubroPrestamoME = {
      secuencialPrestamo: this.secuencialPrestamo
    };
    this.prestamoService.apiV10PrestamoObtenerInformacionRubrosPost(parametro).subscribe(respuesta => {
      this.rubros = respuesta.rubrosPrestamo || [];
      this.cantidad = this.rubros.length;
      this.ListaRubros();
      this.spinner.hide();
    });
  }
}
